// // //offer script
// // // Debounced version of the discount function
// const debouncedRunCartDiscountUI = debounce(runCartDiscountUI, 200);

// // --- Filter eligible items (exclude flashsale/combo/lip/etc) ---
// function getEligibleItems(cartItems) {
//   return cartItems.filter(item => {
//     const type = item.product_type?.toLowerCase();
//     const isExcludedType = [
//       'flashsale', 'flashstore', 'combo', 'merch', 'free', 'lip balm', 'lip care'
//     ].includes(type);
//     return !isExcludedType;
//   });
// }

// // --- Tiered + Lip Balm Bundle Logic ---
// function applyTieredPricing(cartItems) {
//   const eligibleItems = getEligibleItems(cartItems);

//   // --- Lip Balm Bundle ---
//   const lipBalmItems = cartItems.filter(item => {
//     const type = item.product_type?.toLowerCase();
//     return ['lip balm', 'lip care'].includes(type);
//   });

//   let lipBalmUnits = [];
//   lipBalmItems.forEach(item => {
//     const unitPrice = item.final_line_price / item.quantity;
//     for (let i = 0; i < item.quantity; i++) {
//       lipBalmUnits.push({ key: item.key, unitPrice });
//     }
//   });

//   lipBalmUnits.sort((a, b) => b.unitPrice - a.unitPrice);

//   const pairCount = Math.floor(lipBalmUnits.length / 2);
//   const pairedUnitsCount = pairCount * 2;

//   let bundledLipBalm = null;
//   if (pairedUnitsCount > 0) {
//     const bundledLipBalmUnits = lipBalmUnits.slice(0, pairedUnitsCount);
//     const originalTotal = bundledLipBalmUnits.reduce((sum, unit) => sum + unit.unitPrice, 0);
//     bundledLipBalm = {
//       units: bundledLipBalmUnits,
//       discountedTotal: 35000 * pairCount, // paise
//       originalTotal
//     };
//   }

//   // Exclude bundled lip balm units from tier calculation
//   const bundledLipKeys = bundledLipBalm ? bundledLipBalm.units.map(u => u.key) : [];
//   const filteredItems = eligibleItems.filter(item => !bundledLipKeys.includes(item.key));

//   // Build units array for tiered pricing (eligible non-lip items only)
//   const allUnits = [];
//   filteredItems.forEach(item => {
//     const unitPrice = item.final_line_price / item.quantity;
//     for (let i = 0; i < item.quantity; i++) {
//       allUnits.push({ key: item.key, unitPrice });
//     }
//   });

//   // Leftover lip balms (odd one out) are NOT part of tiered pricing
//   const leftoverUnits = lipBalmUnits.slice(pairCount * 2);

//   const totalQty = allUnits.length;

//   const tierPricing = {
//     2: 69900,
//     3: 99900,
//     4: 129500,
//     5: 169800,
//     6: 199800,
//     7: 199800,
//     8: 259000,
//     9: 299700
//   };

//   let discountedTotal = null;
//   let discountedUnits = [];
//   let fullPriceUnits = [];

//   // --- Tier logic ---
//   if (totalQty >= 9) {
//     discountedUnits = allUnits.slice(0, 9);
//     fullPriceUnits = allUnits.slice(9);
//     discountedTotal = tierPricing[9];
//   } else {
//     discountedUnits = allUnits.slice(0, totalQty);
//     fullPriceUnits = [];
//     discountedTotal = tierPricing[totalQty] || null;
//   }

//   // --- Prepare discountedItems array ---
//   const discountedItems = [];
//   if (discountedTotal !== null && discountedUnits.length > 0) {
//     const originalDiscountedTotal = discountedUnits.reduce((sum, unit) => sum + unit.unitPrice, 0);
//     const discountedItemsMap = {};
//     discountedUnits.forEach(unit => {
//       if (!discountedItemsMap[unit.key]) {
//         discountedItemsMap[unit.key] = { quantity: 0, original_total: 0, unit_price: unit.unitPrice };
//       }
//       discountedItemsMap[unit.key].quantity += 1;
//       discountedItemsMap[unit.key].original_total += unit.unitPrice;
//     });

//     Object.entries(discountedItemsMap).forEach(([key, item]) => {
//       const ratio = item.original_total / originalDiscountedTotal;
//       discountedItems.push({
//         key,
//         quantity: item.quantity,
//         original_per_unit: item.unit_price,
//         discounted_total: Math.round(discountedTotal * ratio)
//       });
//     });
//   }

//   // --- Add bundled lip balm discount ---
//   if (bundledLipBalm) {
//     const balmMap = {};
//     bundledLipBalm.units.forEach(unit => {
//       if (!balmMap[unit.key]) {
//         balmMap[unit.key] = { quantity: 0, original_total: 0, unit_price: unit.unitPrice };
//       }
//       balmMap[unit.key].quantity += 1;
//       balmMap[unit.key].original_total += unit.unitPrice;
//     });

//     Object.entries(balmMap).forEach(([key, item]) => {
//       const ratio = item.original_total / bundledLipBalm.originalTotal;
//       discountedItems.push({
//         key,
//         quantity: item.quantity,
//         original_per_unit: item.unit_price,
//         discounted_total: Math.round(bundledLipBalm.discountedTotal * ratio)
//       });
//     });
//   }

//   // --- Prepare nonDiscountedItems array ---
//   const nonDiscountedItems = [];

//   // leftover lip balms (odd one out get no bundle)
//   leftoverUnits.forEach(unit => {
//     const existing = nonDiscountedItems.find(i => i.key === unit.key && i.original_per_unit === unit.unitPrice);
//     if (existing) existing.quantity += 1;
//     else nonDiscountedItems.push({ key: unit.key, original_per_unit: unit.unitPrice, quantity: 1 });
//   });

//   // full price units (10th+)
//   fullPriceUnits.forEach(unit => {
//     const existing = nonDiscountedItems.find(i => i.key === unit.key && i.original_per_unit === unit.unitPrice);
//     if (existing) existing.quantity += 1;
//     else nonDiscountedItems.push({ key: unit.key, original_per_unit: unit.unitPrice, quantity: 1 });
//   });

//   if (discountedItems.length === 0 && nonDiscountedItems.length === 0) return null;

//   return { discountedItems, nonDiscountedItems };
// }

// // --- Update cart UI (merged per key) ---
// function updateCartPricesDisplay(data) {
//   const { discountedItems, nonDiscountedItems } = data;

//   const perKey = {};

//   discountedItems.forEach(d => {
//     if (!perKey[d.key]) perKey[d.key] = { discounted_original: 0, discounted_total: 0, nondiscount_total: 0 };
//     perKey[d.key].discounted_original += d.original_per_unit * d.quantity;
//     perKey[d.key].discounted_total   += d.discounted_total;
//   });

//   nonDiscountedItems.forEach(n => {
//     if (!perKey[n.key]) perKey[n.key] = { discounted_original: 0, discounted_total: 0, nondiscount_total: 0 };
//     perKey[n.key].nondiscount_total += n.original_per_unit * n.quantity;
//   });

//   document.querySelectorAll('.cart-item').forEach(el => {
//     const oldPriceEl = el.querySelector('.cart-item__old-price');
//     const newPriceEl = el.querySelector('.cart-item__final-price');
//     if (!oldPriceEl || !newPriceEl) return;
//     oldPriceEl.style.display = 'none';
//     const original = oldPriceEl.dataset.originalPrice;
//     if (original) newPriceEl.innerText = original;
//   });

//   Object.entries(perKey).forEach(([key, totals]) => {
//     const container = document.querySelector(`[data-key="${key}"]`);
//     if (!container) return;

//     const oldPriceEl = container.querySelector('.cart-item__old-price');
//     const newPriceEl = container.querySelector('.cart-item__final-price');

//     const oldToShow = totals.discounted_original;
//     const newToShow = totals.discounted_total + totals.nondiscount_total;

//     if (oldPriceEl && newPriceEl) {
//       if (oldToShow > 0 && newToShow < oldToShow + totals.nondiscount_total) {
//         oldPriceEl.innerText = `₹${(oldToShow / 100).toFixed(2)}`;
//         oldPriceEl.style.display = 'inline-block';
//       } else {
//         oldPriceEl.style.display = 'none';
//       }
//       newPriceEl.innerText = `₹${(newToShow / 100).toFixed(2)}`;
//     }
//   });
// }

// // --- Fetch cart & run discount ---
// // function runCartDiscountUI() {
// //   fetch('/cart.js')
// //     .then(res => res.ok ? res.json() : Promise.reject('Cart fetch failed'))
// //     .then(cart => {
// //       const data = applyTieredPricing(cart.items);
// //       if (data) {
// //         updateCartPricesDisplay(data);

// //         // --- 🧮 Calculate total savings ---
// //         let totalOriginal = 0;
// //         let totalDiscounted = 0;

// //         data.discountedItems.forEach(d => {
// //           totalOriginal += d.original_per_unit * d.quantity;
// //           totalDiscounted += d.discounted_total;
// //         });

// //         data.nonDiscountedItems.forEach(n => {
// //           totalOriginal += n.original_per_unit * n.quantity;
// //           totalDiscounted += n.original_per_unit * n.quantity;
// //         });

// //         const savings = totalOriginal - totalDiscounted;
// //         const savingsRupees = (savings / 100).toFixed(0);

// //         // console.log(`Cart Savings: ₹${savingsRupees}`);

// //         // ---  Show in the .promo-code-tag div ---
// //         const saveDiv = document.querySelector('.promo-code-tag');
// //         if (saveDiv) {
// //           if (savings > 0) {
// //             saveDiv.textContent = `You Save ₹${savingsRupees}`;
// //           } else {
// //             promoTag.style.display = 'none';;
// //           }
// //         }

// //       } else {
// //         resetCartPricesToOriginal();
// //       }
// //     })
// //     .catch(err => console.error('Error in runCartDiscountUI:', err));
// // }
// function runCartDiscountUI() {
//   fetch('/cart.js')
//     .then(res => res.ok ? res.json() : Promise.reject('Cart fetch failed'))
//     .then(cart => {
//       const data = applyTieredPricing(cart.items);
//       if (data) {
//         updateCartPricesDisplay(data);

//         // --- 🧮 Calculate total savings ---
//         let totalOriginal = 0;
//         let totalDiscounted = 0;

//         data.discountedItems.forEach(d => {
//           totalOriginal += d.original_per_unit * d.quantity;
//           totalDiscounted += d.discounted_total;
//         });

//         data.nonDiscountedItems.forEach(n => {
//           totalOriginal += n.original_per_unit * n.quantity;
//           totalDiscounted += n.original_per_unit * n.quantity;
//         });

//         const savings = totalOriginal - totalDiscounted;
//         const savingsRupees = (savings / 100).toFixed(0);

//         const saveDiv = document.querySelector('.promo-code-tag');
//         if (saveDiv) {
//           // 🔸 Check if combo product exists
//           const hasCombo = cart.items.some(item => {
//             const type = item.product_type?.toLowerCase() || '';
//             return type.includes('combo');
//           });

//           // 🔸 If combo exists, hide saveDiv but don’t stop logic
//           if (hasCombo) {
//             saveDiv.style.display = 'none';
//             saveDiv.textContent = '';
//           } else {
//             if (savings > 0) {
//               saveDiv.style.display = 'block';
//               saveDiv.textContent = `You Save ₹${savingsRupees}`;
//             } else {
//               saveDiv.style.display = 'none';
//               saveDiv.textContent = '';
//             }
//           }
//         }

//       } else {
//         resetCartPricesToOriginal();
//       }
//     })
//     .catch(err => console.error('Error in runCartDiscountUI:', err));
// }



// // --- Reset prices to original ---
// function resetCartPricesToOriginal() {
//   document.querySelectorAll('.cart-item').forEach(item => {
//     const oldPrice = item.querySelector('.cart-item__old-price');
//     const newPrice = item.querySelector('.cart-item__final-price');
//     if (!oldPrice || !newPrice) return;
//     oldPrice.style.display = 'none';
//     const original = oldPrice.dataset.originalPrice;
//     if (original) newPrice.innerText = original;
//   });

//   const saveDiv = document.querySelector('.promo-code-tag');
// if (saveDiv) {
//   saveDiv.style.display = 'none'; // hide it when no savings
//   saveDiv.textContent = ''; // clear text
// }

// }

// // --- Observe cart drawer changes ---
// function observeCartDrawerChanges() {
//   const target = document.querySelector('body');
//   if (!target) return;
//   const observer = new MutationObserver(() => requestAnimationFrame(debouncedRunCartDiscountUI));
//   observer.observe(target, { childList: true, subtree: true });
// }

// // --- Initial triggers ---
// document.addEventListener('DOMContentLoaded', debouncedRunCartDiscountUI);
// document.addEventListener('shopify:section:load', debouncedRunCartDiscountUI);
// observeCartDrawerChanges();




// ===============================
// 🧾 OFFER SCRIPT - Dot & Key (Compare_at_Price Based)
// ===============================

// Debounce helper
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

const debouncedRunCartDiscountUI = debounce(runCartDiscountUI, 100);
function getTotalDiscount() {
  // Select all cart items
  const cartItems = document.querySelectorAll('.cart-item__discounted-prices');
  if (!cartItems.length) return 0; // No items, discount = 0

  let totalOld = 0;
  let totalFinal = 0;

  cartItems.forEach(item => {
    // Old price
    const oldPriceEl = item.querySelector('.cart-item__old-price');
    let oldPrice = 0;
    if (oldPriceEl) {
      const rawOld = oldPriceEl.dataset.originalPrice || oldPriceEl.textContent;
      oldPrice = parseFloat(rawOld.replace(/[^\d.]/g, '')) || 0;
    }

    // Final price
    const finalPriceEl = item.querySelector('.cart-item__final-price');
    let finalPrice = 0;
    if (finalPriceEl) {
      const rawFinal = finalPriceEl.textContent;
      finalPrice = parseFloat(rawFinal.replace(/[^\d.]/g, '')) || 0;
    }

    totalOld += oldPrice;
    totalFinal += finalPrice;
  });

  const discount = totalOld - totalFinal;

  // Only return discount if positive and totalFinal > 0
  if (discount > 0 && totalFinal > 0) {
    return discount.toFixed(2);
  }

  return '0.00';
}





// --- Filter eligible items (exclude flashsale/combo/lip/etc) ---
function getEligibleItems(cartItems) {
  return cartItems.filter(item => {
    const type = item.product_type?.toLowerCase() || '';
    const isExcludedType = ['flashsale', 'flashstore', 'combo', 'merch', 'free', 'lip balm', 'lip care'].includes(type);
    return !isExcludedType;
  });
}

// // --- Tiered + Lip Balm Bundle Logic ---
function applyTieredPricing(cartItems) {
  const eligibleItems = getEligibleItems(cartItems);

  // --- Lip Balm Bundle ---
  const lipBalmItems = cartItems.filter(item => {
    const type = item.product_type?.toLowerCase() || '';
    return ['lip balm', 'lip care'].includes(type);
  });

  let lipBalmUnits = [];
  lipBalmItems.forEach(item => {
    const unitPrice = item.compare_at_price || (item.final_line_price / item.quantity);
    for (let i = 0; i < item.quantity; i++) {
      lipBalmUnits.push({ key: item.key, unitPrice });
    }
  });

  lipBalmUnits.sort((a, b) => b.unitPrice - a.unitPrice);

  const pairCount = Math.floor(lipBalmUnits.length / 2);
  const pairedUnitsCount = pairCount * 2;
  let bundledLipBalm = null;

  if (pairedUnitsCount > 0) {
    const bundledLipBalmUnits = lipBalmUnits.slice(0, pairedUnitsCount);
    const originalTotal = bundledLipBalmUnits.reduce((sum, unit) => sum + unit.unitPrice, 0);
    bundledLipBalm = {
      units: bundledLipBalmUnits,
      discountedTotal: 35000 * pairCount, // ₹350 per pair in paise
      originalTotal
    };
  }

  const bundledLipKeys = bundledLipBalm ? bundledLipBalm.units.map(u => u.key) : [];
  const filteredItems = eligibleItems.filter(item => !bundledLipKeys.includes(item.key));

  // --- Build units for tiered pricing ---
  const allUnits = [];
  filteredItems.forEach(item => {
    const unitPrice = item.compare_at_price || (item.final_line_price / item.quantity);
    for (let i = 0; i < item.quantity; i++) {
      allUnits.push({ key: item.key, unitPrice });
    }
  });

  const leftoverUnits = lipBalmUnits.slice(pairCount * 2);
  const totalQty = allUnits.length;

  const tierPricing = {
    2: 69900,
    3: 99900,
    4: 129500,
    5: 169800,
    6: 199800,
    7: 199800,
    8: 259000,
    9: 299700
  };

  let discountedTotal = null;
  let discountedUnits = [];
  let fullPriceUnits = [];

  if (totalQty >= 9) {
    discountedUnits = allUnits.slice(0, 9);
    fullPriceUnits = allUnits.slice(9);
    discountedTotal = tierPricing[9];
  } else {
    discountedUnits = allUnits.slice(0, totalQty);
    discountedTotal = tierPricing[totalQty] || null;
  }

  // --- Prepare discountedItems array ---
  const discountedItems = [];

  if (discountedTotal !== null && discountedUnits.length > 0) {
    const originalDiscountedTotal = discountedUnits.reduce((sum, unit) => sum + unit.unitPrice, 0);
    const discountedItemsMap = {};

    discountedUnits.forEach(unit => {
      if (!discountedItemsMap[unit.key]) {
        discountedItemsMap[unit.key] = { quantity: 0, original_total: 0, unit_price: unit.unitPrice };
      }
      discountedItemsMap[unit.key].quantity += 1;
      discountedItemsMap[unit.key].original_total += unit.unitPrice;
    });

    Object.entries(discountedItemsMap).forEach(([key, item]) => {
      const ratio = item.original_total / originalDiscountedTotal;
      discountedItems.push({
        key,
        quantity: item.quantity,
        original_per_unit: item.unit_price,
        discounted_total: Math.round(discountedTotal * ratio)
      });
    });
  }

  // --- Add bundled lip balm discount ---
  if (bundledLipBalm) {
    const balmMap = {};
    bundledLipBalm.units.forEach(unit => {
      if (!balmMap[unit.key]) {
        balmMap[unit.key] = { quantity: 0, original_total: 0, unit_price: unit.unitPrice };
      }
      balmMap[unit.key].quantity += 1;
      balmMap[unit.key].original_total += unit.unitPrice;
    });

    Object.entries(balmMap).forEach(([key, item]) => {
      const ratio = item.original_total / bundledLipBalm.originalTotal;
      discountedItems.push({
        key,
        quantity: item.quantity,
        original_per_unit: item.unit_price,
        discounted_total: Math.round(bundledLipBalm.discountedTotal * ratio)
      });
    });
  }

  // --- Non-discounted items ---
  const nonDiscountedItems = [];

  leftoverUnits.forEach(unit => {
    const existing = nonDiscountedItems.find(i => i.key === unit.key && i.original_per_unit === unit.unitPrice);
    if (existing) existing.quantity += 1;
    else nonDiscountedItems.push({ key: unit.key, original_per_unit: unit.unitPrice, quantity: 1 });
  });

  fullPriceUnits.forEach(unit => {
    const existing = nonDiscountedItems.find(i => i.key === unit.key && i.original_per_unit === unit.unitPrice);
    if (existing) existing.quantity += 1;
    else nonDiscountedItems.push({ key: unit.key, original_per_unit: unit.unitPrice, quantity: 1 });
  });

  if (discountedItems.length === 0 && nonDiscountedItems.length === 0) return null;
  return { discountedItems, nonDiscountedItems };
}

// --- Update cart UI ---
function updateCartPricesDisplay(data) {
  const { discountedItems, nonDiscountedItems } = data;
  const perKey = {};

  discountedItems.forEach(d => {
    if (!perKey[d.key]) perKey[d.key] = { discounted_total: 0, nondiscount_total: 0 };
    perKey[d.key].discounted_total += d.discounted_total;
  });

  nonDiscountedItems.forEach(n => {
    if (!perKey[n.key]) perKey[n.key] = { discounted_total: 0, nondiscount_total: 0 };
    perKey[n.key].nondiscount_total += n.original_per_unit * n.quantity;
  });

  document.querySelectorAll('.cart-item__discounted-prices').forEach(container => {
    const key = container.getAttribute('data-key');
    const oldPriceEl = container.querySelector('.cart-item__old-price');
    const finalPriceEl = container.querySelector('.cart-item__final-price');
    if (!oldPriceEl || !finalPriceEl) return;

    const baseOriginal = parseFloat(oldPriceEl.dataset.originalPrice || 0);
    const discounted = perKey[key]?.discounted_total ? perKey[key].discounted_total / 100 : baseOriginal;
    const nondiscount = perKey[key]?.nondiscount_total ? perKey[key].nondiscount_total / 100 : 0;

    const displayFinal = (discounted + nondiscount) < baseOriginal ? (discounted + nondiscount) : baseOriginal;
    const slash = displayFinal < baseOriginal;

    oldPriceEl.textContent = `₹${baseOriginal.toFixed(2)}`;
    oldPriceEl.style.textDecoration = slash ? 'line-through' : 'none';
    oldPriceEl.style.display = 'inline-block';

    finalPriceEl.textContent = `₹${displayFinal.toFixed(2)}`;
    finalPriceEl.style.display = 'inline-block';
  });
}

// --- Reset prices ---
function resetCartPricesToOriginal() {
  document.querySelectorAll('.cart-item__discounted-prices').forEach(container => {
    const oldPrice = container.querySelector('.cart-item__old-price');
    const newPrice = container.querySelector('.cart-item__final-price');
    if (!oldPrice || !newPrice) return;

    oldPrice.style.textDecoration = 'none';
    newPrice.textContent = '';
  });
  const saveDiv = document.querySelector('.promo-code-tag');
  if (saveDiv) {
    saveDiv.style.display = 'none';
    saveDiv.textContent = '';
  }
}

// --- Main function ---

// function runCartDiscountUI() {
//   fetch('/cart.js')
//     .then(res => res.ok ? res.json() : Promise.reject('Cart fetch failed'))
//     .then(cart => {

//       // 🛑 If only 1 item in cart — show normal compare_at (slash) + sale price only
//       if (cart.item_count <= 1) {
//         console.log('🛑 Offer disabled — only 1 item in cart');

//         document.querySelectorAll('.cart-item__discounted-prices').forEach(container => {
//           const oldPriceEl = container.querySelector('.cart-item__old-price');
//           const finalPriceEl = container.querySelector('.cart-item__final-price');

//           if (oldPriceEl && finalPriceEl) {
//             // Read compare_at_price (old) and sale price (current)
//             const compareText = oldPriceEl.dataset.originalPrice || oldPriceEl.textContent;
//             const saleText = finalPriceEl.dataset.salePrice || finalPriceEl.textContent || compareText;

//             const comparePrice = parseFloat(compareText.replace(/[^\d.]/g, '')) || 0;
//             const salePrice = parseFloat(saleText.replace(/[^\d.]/g, '')) || comparePrice;

//             // --- Update UI ---
//             // Show slash on compare_at_price
//             oldPriceEl.textContent = `₹${comparePrice.toFixed(2)}`;
//             oldPriceEl.style.textDecoration = 'line-through';
//             oldPriceEl.style.display = 'inline-block';

//             // Show sale price (normal product price)
//             finalPriceEl.textContent = `₹${salePrice.toFixed(2)}`;
//             finalPriceEl.style.display = 'inline-block';
//           }
//         });

//         // Hide any offer saving tag
//         const saveDiv = document.querySelector('.promo-code-tag');
//         if (saveDiv) {
//           saveDiv.style.display = 'none';
//           saveDiv.textContent = '';
//         }

//         return; // Stop here, don't apply offer logic
//       }

//       // ✅ Otherwise apply offer logic (tiered + lip balm)
//       const data = applyTieredPricing(cart.items);
//       if (data) {
//         updateCartPricesDisplay(data);
//       } else {
//         resetCartPricesToOriginal();
//       }

//       // ✅ Update “You Save” tag
//       const saveDiv = document.querySelector('.promo-code-tag');
//       const savings = getTotalDiscount();

//       if (!savings || isNaN(savings) || Number(savings) === 0) {
//         saveDiv.style.display = 'none';
//         saveDiv.textContent = '';
//       } else {
//         console.log('Savings:', savings);
//         saveDiv.style.display = 'block';
//         saveDiv.textContent = 'You Save ₹' + savings;
//       }
//     })
//     .catch(err => console.error('Error in runCartDiscountUI:', err));
// }
function runCartDiscountUI() {
  fetch('/cart.js')
    .then(res => res.ok ? res.json() : Promise.reject('Cart fetch failed'))
    .then(cart => {

      // 🛑 If only 1 item in cart — show normal compare_at (slash) + sale price only
      if (cart.item_count <= 1) {
        console.log('🛑 Offer disabled — only 1 item in cart');

        document.querySelectorAll('.cart-item__discounted-prices').forEach(container => {
          const oldPriceEl = container.querySelector('.cart-item__old-price');
          const finalPriceEl = container.querySelector('.cart-item__final-price');

          if (oldPriceEl && finalPriceEl) {
            // Read compare_at_price (old) and sale price (current)
            const compareText = oldPriceEl.dataset.originalPrice || oldPriceEl.textContent;
            const saleText = finalPriceEl.dataset.salePrice || finalPriceEl.textContent || compareText;

            const comparePrice = parseFloat(compareText.replace(/[^\d.]/g, '')) || 0;
            const salePrice = parseFloat(saleText.replace(/[^\d.]/g, '')) || comparePrice;

            // --- Update UI ---
            if (comparePrice > salePrice) {
              // Show slash compare_at_price + sale price
              oldPriceEl.textContent = `₹${comparePrice.toFixed(2)}`;
              oldPriceEl.style.textDecoration = 'line-through';
              oldPriceEl.style.display = 'inline-block';

              finalPriceEl.textContent = `₹${salePrice.toFixed(2)}`;
              finalPriceEl.style.display = 'inline-block';
            } else {
              // Hide compare price if same as sale
              oldPriceEl.style.display = 'none';
              finalPriceEl.textContent = `₹${salePrice.toFixed(2)}`;
              finalPriceEl.style.display = 'inline-block';
            }
          }
        });

        // Hide any offer saving tag
        const saveDiv = document.querySelector('.promo-code-tag');
        if (saveDiv) {
          saveDiv.style.display = 'none';
          saveDiv.textContent = '';
        }

        return; // Stop here, don't apply offer logic
      }

      // ✅ Otherwise apply offer logic (tiered + lip balm)
      const data = applyTieredPricing(cart.items);
      if (data) {
        updateCartPricesDisplay(data);
      } else {
        resetCartPricesToOriginal();
      }

      // ✅ Update “You Save” tag
      const saveDiv = document.querySelector('.promo-code-tag');
      const savings = getTotalDiscount();

      if (!savings || isNaN(savings) || Number(savings) === 0) {
        saveDiv.style.display = 'none';
        saveDiv.textContent = '';
      } else {
        console.log('Savings:', savings);
        saveDiv.style.display = 'block';
        saveDiv.textContent = 'You Save ₹' + savings;
      }
    })
    .catch(err => console.error('Error in runCartDiscountUI:', err));
}


// --- Observe cart drawer changes ---
function observeCartDrawerChanges() {
  const target = document.querySelector('body');
  if (!target) return;
  const observer = new MutationObserver(() => requestAnimationFrame(debouncedRunCartDiscountUI));
  observer.observe(target, { childList: true, subtree: true });
}

// --- Initial triggers ---
document.addEventListener('DOMContentLoaded', debouncedRunCartDiscountUI);
document.addEventListener('shopify:section:load', debouncedRunCartDiscountUI);
observeCartDrawerChanges();

